import { Card } from "antd";
import "./editable-details-card-wrapper.scss";

function EditableDetailsCardWrapper(props: any) {
  const { title, children, extra } = props;
  return (
    <Card
      title={title}
      className="ciq-card-block"
      extra={extra}
      data-testid="editable-details-card-wrapper"
    >
      <div
        className="grow overflow-auto"
        data-testid="editable-details-card-content"
      >
        {children}
      </div>
    </Card>
  );
}

export default EditableDetailsCardWrapper;
